import { appManifestSchema } from '../contracts/app-v2.mjs';

// The payload is the existing C1 app.json declaration. ART/DATA own the
// enclosing saved Artifact, source inventory and original version association.
export const appArtifactDescriptor = Object.freeze({
  id: 'app',
  schemaVersion: 1,
  labelKey: 'artifacts.kind.app',
  payloadSchema: appManifestSchema,
  capabilities: Object.freeze({
    authoring: true,
    inspector: true,
    refresh: true,
    present: false,
    readOnlyReact: false,
  }),
  exportFormats: Object.freeze([]),
  enabledIn: Object.freeze(['pr2']),
});
